import { useEffect, useRef, useState } from "react";
import { Palette } from "lucide-react";
import { THEMES, getTheme, setTheme } from "@/lib/theme";

export default function ThemeSwitcher({ compact }) {
  const [theme, setT] = useState(getTheme());
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => { document.documentElement.setAttribute("data-theme", theme); }, [theme]);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  const pick = (id) => { setT(id); setTheme(id); setOpen(false); };

  return (
    <div className="relative" ref={wrapRef} data-testid="theme-switcher">
      <button onClick={() => setOpen(v => !v)} className="pf-btn flex items-center gap-1 text-sm"
        data-testid="theme-switcher-btn" title="Theme" aria-expanded={open}>
        <Palette size={16} />{!compact && <span className="hidden sm:inline">Theme</span>}
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 w-44 z-50 pf-surface border-2 pf-border rounded-xl overflow-hidden shadow-2xl"
          data-testid="theme-switcher-menu">
          {THEMES.map(t => (
            <button key={t.id} onClick={() => pick(t.id)} data-testid={`theme-opt-${t.id}`}
              className={`block w-full text-left px-3 py-2 text-sm hover:opacity-80 ${theme === t.id ? "pf-accent-bg font-bold" : ""}`}>
              {t.label}{theme === t.id ? " ✓" : ""}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
